<emob-modal-card>
  <emob-modal-card-header>
    {{ 'ALERTING.MUTE_STATION' | translate }}
  </emob-modal-card-header>
  <emob-modal-card-content class="mute-content" [compact]="true">
    <eop-grid-list [columns]="1">
      <div class="description">{{ 'ALERTING.MUTE_STATION_DESC' | translate }}</div>
      <div class="station-detail-content">
        <div class="body-s station-detail-title">
          {{ 'GLOBAL.CHARGING_STATION' | translate }}
        </div>
        <div class="icon-with-text">
          <eop-icon
            [identifier]="'ic-charging-station'"
            [vaylensFont]="true"
            [size]="IconSize.SMALL"
            [color]="IconColor.NORMAL"></eop-icon>
          <div class="body-m status-label">
            {{ modalData.stationName }}
          </div>
        </div>
        <div class="icon-with-text small">
          <eop-icon
            [identifier]="'location-outlined'"
            [vaylensFont]="true"
            [size]="IconSize.MINI"
            [color]="IconColor.NORMAL"></eop-icon>
          <div class="body-s status-label">
            {{ modalData.street | empty }}, {{ modalData | location: LocationTypes.LINE2 | empty }},
            {{ modalData.country ? ('GLOBAL.' + modalData.country | translate) : '' }}
          </div>
        </div>
      </div>
      <form [formGroup]="form">
        <eop-form-input-item
          [title]="'ALERTING.MUTE_STATION_DURATION' | translate"
          formControlValidate="mutedUntil">
          <emob-dropdown
            [items]="durations"
            [placeholder]="'ALERTING.MUTE_STATION_DURATION' | translate"
            [singleSelectDeselactable]="false"
            data-test="mutedUntil"
            formControlName="mutedUntil"></emob-dropdown>
        </eop-form-input-item>

        <eop-form-input-item
          [title]="'ALERTING.MUTE_STATION_NOTE' | translate"
          formControlValidate="userNote">
          <textarea
            data-test="userNote"
            [placeholder]="'ALERTING.MUTE_STATION_NOTE' | translate"
            formControlName="userNote"
            class="user-note"
            maxlength="256"></textarea>
        </eop-form-input-item>
      </form>
    </eop-grid-list>
  </emob-modal-card-content>
  <emob-modal-card-footer class="mute-footer">
    <button (click)="onClose()" [color]="ButtonColor.TERTIARY" data-test="cancel" eopButton>
      <span>{{ 'GLOBAL.CANCEL' | translate }}</span>
    </button>
    <button
      (click)="onMute()"
      [color]="ButtonColor.ERROR"
      data-test="mute"
      [disabled]="form.invalid"
      eopButton>
      <span>{{ 'ALERTING.MUTE_STATION_PAUSE' | translate }}</span>
    </button>
  </emob-modal-card-footer>
</emob-modal-card>
